/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, Solution} from '@exc/core/src/models/Solution';

const CONFIG: Solution = {
  appId: 'implement',
  distributionList: ['activation-engineering@adobe.com'],
  name: 'Implement',
  path: '/implement',
  analytics: {code: 'launch'},
  gainsight: {productKey: 'AP-ICU715RZNQ41-2'},
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost:9004',
      dev1: 'https://activation-dev.adobe.com',
      qa: 'https://activation-qe.adobe.com',
      stage: 'https://activation-stage.adobe.com',
      prod: 'https://activation.adobe.com'
    }
  }
};

export default CONFIG;
